import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/zuixin-baoliao', label: '分类浏览' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="container-custom flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-chat-smile-2-line text-lg md:text-xl"></i>
          </div>
          <span className={`font-heading text-lg md:text-xl font-bold whitespace-nowrap ${
            isScrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
          }`}>
            黑料社区
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.to
                  ? 'text-primary-600'
                  : isScrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
              isScrolled || !isHome
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30'
            }`}
          >
            加入社区
          </Link>
        </div>

        <button
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${
            isScrolled || !isHome ? 'text-foreground-800' : 'text-background-50'
          } ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="container-custom py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 transition-colors cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 px-4 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium text-center whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              加入社区
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}